export const UserIconV2 = ({ height = 30, width = 30, color = '#00FF99' }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 30 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.60815 18.7498C10.3463 18.7498 11.0698 18.9272 11.7699 19.1611C12.7872 19.5009 13.871 19.6873 14.9997 19.6873C16.1262 19.6873 17.2113 19.5015 18.2261 19.1631C18.929 18.9286 19.6553 18.7498 20.3964 18.7498L22.4999 18.7498C26.6425 18.7498 30 22.1074 30 26.2499L30 27.1875C30 28.7402 28.7402 30 27.1875 30L2.81255 30C1.25982 30 1.17743e-05 28.7402 9.78043e-08 27.1875L9.44317e-08 26.2499C7.95291e-08 22.1074 3.35754 18.7498 7.50013 18.7498L9.60815 18.7498Z"
        fill={color}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.9997 -5.39602e-08C19.658 -7.07177e-08 23.4374 3.77943 23.4374 8.43764C23.4373 13.0957 19.6579 16.8748 14.9997 16.8748C10.3417 16.8747 6.56274 13.0957 6.56261 8.43764C6.56261 3.77948 10.3416 8.27171e-05 14.9997 -5.39602e-08ZM18.4309 12.5944C18.2925 12.4338 18.0506 12.4174 17.8796 12.5427C17.0536 13.1479 16.0547 13.4796 15.0244 13.4848C13.994 13.4899 12.992 13.1681 12.1601 12.5713C11.9878 12.4478 11.746 12.4666 11.6092 12.6286C11.4725 12.7906 11.4925 13.0344 11.6635 13.1599C12.6361 13.8735 13.8153 14.2587 15.0284 14.2525C16.2415 14.2464 17.4168 13.8491 18.3822 13.1257C18.5517 12.9986 18.5692 12.755 18.4309 12.5944Z"
        fill={color}
      />
    </svg>
  );
};
